import { baseApi } from "./base";

/**
 * Ky instance for querying the Vimeo endpoint
 */
export const vimeoApi = baseApi.extend({
	headers: {
		Accept: "application/json",
		"sec-ch-ua-mobile": "?0",
		"Sec-Fetch-Dest": "empty",
		"Sec-Fetch-Mode": "cors",
		"Sec-Fetch-Site": "cross-site",
		"X-Ky-Instance": "vimeoApi",
	},
	prefixUrl: "https://vimeo.com/api",
});
